// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3JHNW","header":"ClearentDisclaimer_header__2lTks","inner":"ClearentDisclaimer_inner__1vHZo"};